<template>
  <div class="ChangePass">
    <box :title="$t('changePass')">
      <div class="pa-2">
        <v-form v-model="form">
          <v-row>
            <v-col cols="12" sm="7">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("oldPass") }} : </label>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="oldPass"
                    :rules="[$rules.required]"
                    solo
                    :placeholder="$t('oldPass')"
                    dense
                    type="password"
                    hide-details=""
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="7">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("newPass") }} : </label>
                </v-col>
                <v-col>
                  <v-text-field
                    :rules="[$rules.required]"
                    solo
                    :placeholder="$t('newPass')"
                    v-model.lazy="newPass"
                    dense
                    type="password"
                    hide-details=""
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" sm="7">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("confirmNewPass") }} : </label>
                </v-col>
                <v-col>
                  <v-text-field
                    :rules="[$rules.required, $rules.equal(newPass)]"
                    solo
                    :placeholder="$t('confirmNewPass')"
                    dense
                    type="password"
                    hide-details=""
                    v-model.lazy="confirmPass"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </div>
      <div class="d-flex pb-2 px-2">
        <v-spacer></v-spacer>
        <v-btn class="mx-1" color="primary" @click="cancel" outlined>{{ $t("cancel") }}</v-btn>
        <v-btn
          :disabled="!form"
          class=""
          color="primary"
          @click="onClickChangePass"
          >{{ $t("changePass") }}</v-btn
        >
      </div>
    </box>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";
export default {
  data() {
    return {
      form: false,
      oldPass: "",
      newPass: "",
      confirmPass: "",
      args: null,
    };
  },
  mounted() {
    if (this.$route.query) {
      this.args = this.$route.query;
    }
  },
  methods: {
    onClickChangePass() {
      var perno = this.$store.state.auth.auth.username;
      //check old pass
      var username = TextUtils.convertToEnglishDigits(perno);
      var password = TextUtils.convertToEnglishDigits(this.oldPass);
      console.log(perno, username, this.newPass, this.oldPass);
      if (!username || !this.newPass || !this.oldPass) {
        //warning empty values
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: this.$t("empty-username-password-error"),
        });
        return;
      }

      this.loading = true;

      this.$store
        .dispatch("checkLogin", { username, password })
        .then((result) => {
          if (result.type === ResultType.success) {
            this.changePass(perno);
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "رمز عبور قبلی نادرست می باشد",
              timer: 5000,
            });
          }
        });
    },
    changePass(perno) {
    
      var resultCheckkUser;
      resultCheckkUser=EosUtils.isWebKartAdmin1(resultCheckkUser);
      debugger;
      // if (!EosUtils.isWebKartAdmin) {
      if (resultCheckkUser) {
        this.$store
          .dispatch("ChangeAdminPassword", {
            params: {
              password: TextUtils.convertToEnglishDigits(this.newPass),
            },
          })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: result.error || this.$t("operationFailed"),
              });
            }
          });
      } else {
        var params = {
          password: TextUtils.convertToEnglishDigits(this.newPass),
          perno: perno,
        };

        this.$store.dispatch("ChangePassword", { params }).then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
      }
    },
    cancel(){
    
      var query = {
        pid: this.args.pid,
      };
      debugger;
      this.$router.push({ name: "adminHome", query: query });
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 130px;
}
</style>